import { WorkOrderRequestTypes } from '../ActionTypes/WorkOrderRequestTypes';

let initialSate = {
    WorkOrderRequestCustomers: [],
    WorkOrderRequestCustomerDetails : [],
    WorkOrderRequestList: [],

};

const WorkOrderRequestReducer = (state = initialSate, action) => {
    switch (action.type) {

        case WorkOrderRequestTypes.GET_WORK_ORDER_REQUEST_CUSTOMERS:
            state = { ...state, WorkOrderRequestCustomers : action.payload };
            break;

        case WorkOrderRequestTypes.CLEAR_WORK_ORDER_REQUEST_CUSTOMERS:
            state = {
                WorkOrderRequestCustomers : []
            };
            break;

        case WorkOrderRequestTypes.GET_WORK_ORDER_REQUEST_LIST :
            state = { ...state, WorkOrderRequestList : action.payload };
            break;
            
        case WorkOrderRequestTypes.CLEAR_WORK_ORDER_REQUEST_LIST:
            state = {
                WorkOrderRequestList : []
            };
            break;
        
    }
    return state;
};

export default WorkOrderRequestReducer;
